export default __webpack_public_path__ + "static/AMCE-86c162f2c4ef589e106d22acc3187e55.png";